export function getProductCardDomId(productCardId?: string, entryId?: string): string {
  return productCardId || `product-card-${entryId ?? ""}`;
}

export function isScrollHighlightedCard(
  highlightedCardId: string | null,
  productCardId?: string,
  entryId?: string,
): boolean {
  if (!highlightedCardId) return false;
  return highlightedCardId === getProductCardDomId(productCardId, entryId);
}

export function computeGalleryRecommendedFlag(params: {
  disableRecommendedFlag: boolean;
  extended: boolean;
  hasFlagContent: boolean;
  index: number;
  currentPage: number;
}): boolean {
  return (
    !params.disableRecommendedFlag &&
    !params.extended &&
    params.hasFlagContent &&
    params.index === 0 &&
    params.currentPage === 1
  );
}
